import ErrorBoundary from "ErrorBoundary";
import "./App.css";
import "./assets/css/global.css";
import "./assets/css/responsive.css";
import { UserContextProvider } from "context";
import Router from "router/Router";
import { useNetworkStatus } from "hooks";
import toast, { Toaster } from 'react-hot-toast';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

import React, { useEffect } from "react";
import { GoogleMapsProvider } from "components/GoogleMapsProvider/GoogleMapsProvider";
import { utils } from "helper";
export const ToggleSidebar = React.createContext(null);

function App() {
  const isOnline = useNetworkStatus();
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: false,
        retry: 1,
      },
    },
  });

  // useEffect(() => {
  //   utils.disableConsoleLogs();
  // }, []);

  return (
    <QueryClientProvider client={queryClient}>
      <UserContextProvider>
        <GoogleMapsProvider>
          <ErrorBoundary>
            {!isOnline && <div className="__oflineBar">No Internet Connection</div>}
            <Router />
            <Toaster />
          </ErrorBoundary>
        </GoogleMapsProvider>
      </UserContextProvider>
    </QueryClientProvider>
  );
}

export default App;
